var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAggregator = function SvgAggregator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__a)",
    d: "M53.58 13.204 34.078.877a1.5 1.5 0 0 0-1.606 0L12.967 13.204a1.503 1.503 0 0 0 .803 2.773h39.008a1.503 1.503 0 0 0 .803-2.773"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BB7FF",
    d: "M50.212 16.877H44.98c-.83 0-1.504.673-1.504 1.503v22.015c0 .83.674 1.503 1.504 1.503h5.23c.83 0 1.504-.673 1.504-1.503V18.38c0-.83-.673-1.503-1.503-1.503M35.89 16.877h-5.232c-.83 0-1.503.673-1.503 1.503v22.015c0 .83.673 1.503 1.503 1.503h5.231c.83 0 1.503-.673 1.503-1.503V18.38c0-.83-.672-1.503-1.503-1.503M21.464 16.877h-5.231c-.83 0-1.504.673-1.504 1.503v22.015c0 .83.673 1.503 1.504 1.503h5.23c.83 0 1.504-.673 1.504-1.503V18.38c0-.83-.673-1.503-1.503-1.503"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__b)",
    d: "M55.566 12.973H10.984a2.8 2.8 0 0 0-2.8 2.799v2.877a2.8 2.8 0 0 0 2.8 2.799h44.582a2.8 2.8 0 0 0 2.799-2.799v-2.877a2.8 2.8 0 0 0-2.8-2.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__c)",
    d: "M52.779 37.451H13.77c-.83 0-1.503.673-1.503 1.503v5.47c0 .83.672 1.502 1.503 1.502h39.008c.83 0 1.503-.672 1.503-1.503v-5.469c0-.83-.673-1.503-1.503-1.503"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__d)",
    d: "M56.863 42.92H9.689c-.83 0-1.503.673-1.503 1.503v5.47c0 .83.672 1.502 1.503 1.502h47.174c.83 0 1.503-.673 1.503-1.503v-5.469c0-.83-.673-1.503-1.503-1.503"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__e)",
    d: "M22.32 56.342c.001.266-.043.53-.13.78l-1.45 3.83a2.5 2.5 0 0 1-4.67-1.76l1.41-3.74a2 2 0 0 1 .34-.61 2.5 2.5 0 0 1 4.5 1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__f)",
    d: "M27.35 57.173c0 .297-.054.592-.16.87l-1.77 4.67a2.5 2.5 0 1 1-4.68-1.76l1.45-3.83.32-.84a2.5 2.5 0 0 1 4.84.89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__g)",
    d: "M36 62.552c0 .297-.054.592-.16.87l-.61 1.62-.45 1.18a2.5 2.5 0 0 1-4.68-1.75l1.08-2.86a2.5 2.5 0 0 1 4.82.94"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__h)",
    d: "M32.03 58.932c0 .298-.054.593-.16.87l-.69 1.81-1.08 2.86a2.5 2.5 0 0 1-4.68-1.76l1.77-4.67a2.5 2.5 0 0 1 4.84.89"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__i)",
    d: "M49.38 52.46a2.5 2.5 0 0 0-1.18-3.33l-12.36-6.34-5.74 5.18a2.978 2.978 0 0 1-4.96-2.23c-.006-.74.269-1.454.77-2l6.27-6.9.91-1a3.05 3.05 0 0 1 2.26-1L51 34.82l3.28 18.02h-5.13a1.8 1.8 0 0 0 .23-.38"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__j)",
    d: "M36.34 44.689a1 1 0 0 1-.67-1.743l2.16-1.95a1 1 0 1 1 1.34 1.485l-2.16 1.95a1 1 0 0 1-.67.258"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__k)",
    d: "M61 54.842h-4.959a1.68 1.68 0 0 1-1.652-1.379l-3.39-18.641a1.68 1.68 0 0 1 1.653-1.98H61a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__l)",
    d: "M49.38 52.46a1.8 1.8 0 0 1-.23.38 2.465 2.465 0 0 1-3.1.8 2.5 2.5 0 0 1 1.42 2.26 2.6 2.6 0 0 1-.24 1.08 2.49 2.49 0 0 1-2.26 1.42 2.6 2.6 0 0 1-1.07-.24 2.5 2.5 0 0 1-1.07 4.75 2.6 2.6 0 0 1-1.08-.24 2.49 2.49 0 0 1 1.42 2.261 2.6 2.6 0 0 1-.24 1.08 2.483 2.483 0 0 1-3.32 1.17l-4.38-2.14.61-1.62a2.5 2.5 0 0 0-4.66-1.81l.69-1.81a2.5 2.5 0 0 0-4.68-1.76 2.5 2.5 0 1 0-4.68-1.76l-.32.84c.087-.25.131-.515.13-.78a2.5 2.5 0 0 0-4.5-1.5h-4.1L17 36.82l15.18.02-6.27 6.9c-.5.545-.776 1.26-.77 2a2.978 2.978 0 0 0 4.96 2.23l5.74-5.18 12.36 6.34a2.5 2.5 0 0 1 1.18 3.33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__m)",
    d: "M7 56.842h4.958a1.68 1.68 0 0 0 1.652-1.379L17 36.822a1.68 1.68 0 0 0-1.653-1.98H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aggregator_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aggregator_svg__o)",
    d: "M40.104 11.543a6.635 6.635 0 1 1-13.269 0 6.635 6.635 0 0 1 13.27 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.196 9.963h-.903a2.2 2.2 0 0 0-.234-.567h1.137a.542.542 0 0 0 0-1.084h-5.117a.542.542 0 0 0 0 1.084h2.09c.415 0 .777.229.967.567h-3.057a.542.542 0 1 0 0 1.083h3.057c-.19.338-.552.567-.967.567h-2.09a.542.542 0 0 0-.395.912l2.946 3.127a.54.54 0 0 0 .766.023.54.54 0 0 0 .022-.766l-2.085-2.213h.836a2.195 2.195 0 0 0 2.124-1.65h.903a.542.542 0 1 0 0-1.083"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(149.604 19.726 6.85)scale(23.6483 27.4021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(164.811 19.834 9.846)scale(25.2442 16.9469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-37.39832 14.27804 -9.10932 -23.85994 68.073 30.896)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(169.732 25.321 24.186)scale(43.0612 14.0472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(117.122 -6.84 34.53)scale(7.75353 17.8802)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C78D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.831 -5.172 36.807)scale(8.63418 19.2447)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C99553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.34926 6.20105 -14.73614 -7.95916 34.535 62.306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C99553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.831 -3.383 39.153)scale(8.63418 19.2447)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C78D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(138.192 15.94 29.066)scale(21.7221 61.3442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.064 8.585 30.74)scale(3.92728 10.6215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6B29"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.1241 -18.94408 18.22453 -11.66359 61.787 49.415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.94913 24.59473 -68.38607 -55.46891 40.897 45.798)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED39B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.1241 -18.94408 18.22453 -11.66359 15.813 51.415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aggregator_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.37284 10.66284 -28.34853 -19.60165 36.879 8.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aggregator_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.836 4.871h13.306v13.306H26.836z"
  })))));
};
export default SvgAggregator;